export default __webpack_public_path__ + "static/media/AU.ffba0801.svg";